
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_l0dv0_eq5ql_10",
  "with-toolbar": "awsui_with-toolbar_l0dv0_eq5ql_44",
  "header": "awsui_header_l0dv0_eq5ql_48",
  "list--with-icons": "awsui_list--with-icons_l0dv0_eq5ql_61",
  "header-link": "awsui_header-link_l0dv0_eq5ql_65",
  "header-link--has-logo": "awsui_header-link--has-logo_l0dv0_eq5ql_76",
  "header-link-text": "awsui_header-link-text_l0dv0_eq5ql_76",
  "header-logo": "awsui_header-logo_l0dv0_eq5ql_81",
  "header-logo--stretched": "awsui_header-logo--stretched_l0dv0_eq5ql_87",
  "items-control": "awsui_items-control_l0dv0_eq5ql_92",
  "list-container": "awsui_list-container_l0dv0_eq5ql_97",
  "divider-header": "awsui_divider-header_l0dv0_eq5ql_105",
  "root--collapsed": "awsui_root--collapsed_l0dv0_eq5ql_109",
  "list": "awsui_list_l0dv0_eq5ql_61",
  "list-variant-root": "awsui_list-variant-root_l0dv0_eq5ql_122",
  "list-variant-root--first": "awsui_list-variant-root--first_l0dv0_eq5ql_129",
  "list-variant-root--collapsed": "awsui_list-variant-root--collapsed_l0dv0_eq5ql_132",
  "list-variant-expandable-link-group": "awsui_list-variant-expandable-link-group_l0dv0_eq5ql_139",
  "list-variant-expandable-link-group--collapsed": "awsui_list-variant-expandable-link-group--collapsed_l0dv0_eq5ql_145",
  "list-variant-section": "awsui_list-variant-section_l0dv0_eq5ql_149",
  "list-variant-section--collapsed": "awsui_list-variant-section--collapsed_l0dv0_eq5ql_152",
  "list-variant-link-group": "awsui_list-variant-link-group_l0dv0_eq5ql_161",
  "list-variant-link-group--collapsed": "awsui_list-variant-link-group--collapsed_l0dv0_eq5ql_177",
  "link-group-children": "awsui_link-group-children_l0dv0_eq5ql_194",
  "link-group-children--collapsed": "awsui_link-group-children--collapsed_l0dv0_eq5ql_211",
  "link-group-children-inner": "awsui_link-group-children-inner_l0dv0_eq5ql_228",
  "link-group-children-inner--expanded": "awsui_link-group-children-inner--expanded_l0dv0_eq5ql_247",
  "link-group-children-inner--settled": "awsui_link-group-children-inner--settled_l0dv0_eq5ql_263",
  "list-variant-section-group": "awsui_list-variant-section-group_l0dv0_eq5ql_267",
  "list-variant-section-group--collapsed": "awsui_list-variant-section-group--collapsed_l0dv0_eq5ql_273",
  "list-item": "awsui_list-item_l0dv0_eq5ql_277",
  "list-item--collapsed": "awsui_list-item--collapsed_l0dv0_eq5ql_290",
  "list-item--link-with-info": "awsui_list-item--link-with-info_l0dv0_eq5ql_296",
  "list-item--group": "awsui_list-item--group_l0dv0_eq5ql_301",
  "section": "awsui_section_l0dv0_eq5ql_301",
  "section-group": "awsui_section-group_l0dv0_eq5ql_302",
  "expandable-link-group": "awsui_expandable-link-group_l0dv0_eq5ql_307",
  "section--no-ident": "awsui_section--no-ident_l0dv0_eq5ql_310",
  "section--expand-icon-end": "awsui_section--expand-icon-end_l0dv0_eq5ql_310",
  "expandable-link-group--no-ident": "awsui_expandable-link-group--no-ident_l0dv0_eq5ql_311",
  "expandable-link-group--expand-icon-end": "awsui_expandable-link-group--expand-icon-end_l0dv0_eq5ql_312",
  "section--collapsed": "awsui_section--collapsed_l0dv0_eq5ql_315",
  "expandable-link-group--collapsed": "awsui_expandable-link-group--collapsed_l0dv0_eq5ql_316",
  "expandable-link-group--active": "awsui_expandable-link-group--active_l0dv0_eq5ql_340",
  "item-icon": "awsui_item-icon_l0dv0_eq5ql_344",
  "refresh": "awsui_refresh_l0dv0_eq5ql_387",
  "section-header": "awsui_section-header_l0dv0_eq5ql_438",
  "section-group-title": "awsui_section-group-title_l0dv0_eq5ql_453",
  "section-group-title--collapsed": "awsui_section-group-title--collapsed_l0dv0_eq5ql_474",
  "link": "awsui_link_l0dv0_eq5ql_194",
  "link-active": "awsui_link-active_l0dv0_eq5ql_532",
  "link--collapsed": "awsui_link--collapsed_l0dv0_eq5ql_539",
  "header-link-active": "awsui_header-link-active_l0dv0_eq5ql_659",
  "link-text-wrapper-content": "awsui_link-text-wrapper-content_l0dv0_eq5ql_688",
  "link-text-wrapper": "awsui_link-text-wrapper_l0dv0_eq5ql_688",
  "link-text-wrapper--collapsed": "awsui_link-text-wrapper--collapsed_l0dv0_eq5ql_715",
  "label-text": "awsui_label-text_l0dv0_eq5ql_737",
  "label-text--collapsed": "awsui_label-text--collapsed_l0dv0_eq5ql_757",
  "info": "awsui_info_l0dv0_eq5ql_776",
  "item-icon--collapsed": "awsui_item-icon--collapsed_l0dv0_eq5ql_798",
  "external-icon": "awsui_external-icon_l0dv0_eq5ql_802",
  "divider": "awsui_divider_l0dv0_eq5ql_105",
  "divider-default": "awsui_divider-default_l0dv0_eq5ql_810",
  "divider--collapsed": "awsui_divider--collapsed_l0dv0_eq5ql_814",
  "section--expand-icon-end-with-info": "awsui_section--expand-icon-end-with-info_l0dv0_eq5ql_844"
};
  